import React from 'react'
import SearchPreviewPane from './SearchPreviewPane'

// Right-column preview on the search-results page. Hosts the same preview
// components as the dropdown but is driven by the currently-active result row
// rather than the highlighted suggestion. The container handles sticky
// positioning, height cap and the bottom fade gradient.
function SearchResultsPreviewPanel({ activeHit, activeItemType }) {
  // Only library rows (set / question / pack / folder) have something to
  // preview. When there's no previewable active row — an empty result set, or a
  // nav / external row — render nothing: the results page intentionally has no
  // empty-state placeholder card.
  const previewable = activeItemType === 'set' ||
    activeItemType === 'question' ||
    activeItemType === 'repo' ||
    activeItemType === 'folder'
  if (!previewable) return null
  return (
    <div className='searchResults-previewPanel'>
      <SearchPreviewPane suggestion={activeHit} />
      <div className='searchResults-previewPanel-fade' aria-hidden='true' />
    </div>
  )
}

export default SearchResultsPreviewPanel
